// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZodiacWheel_wrapper__hdiG1 {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 0;
  width: 100%;
}

.ZodiacWheel_wheel__OpkyY {
  width: 100%;
  max-width: 360px;
  height: auto;
}

.ZodiacWheel_zodiacIcon__z\\+\\+WF {
  filter: brightness(0.8) contrast(0.9);
  opacity: 0.7;
  transition: filter 0.3s ease;
}
`, "",{"version":3,"sources":["webpack://./src/components/ZodiacWheel/ZodiacWheel.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,4BAA4B;AAC9B","sourcesContent":[".wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 12px 0;\n  width: 100%;\n}\n\n.wheel {\n  width: 100%;\n  max-width: 360px;\n  height: auto;\n}\n\n.zodiacIcon {\n  filter: brightness(0.8) contrast(0.9);\n  opacity: 0.7;\n  transition: filter 0.3s ease;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `ZodiacWheel_wrapper__hdiG1`,
	"wheel": `ZodiacWheel_wheel__OpkyY`,
	"zodiacIcon": `ZodiacWheel_zodiacIcon__z++WF`
};
export default ___CSS_LOADER_EXPORT___;
